document.addEventListener("DOMContentLoaded", function() {
  // Selektiere die Navigationselemente aus dem Dropdown-Navigation-Bereich
  const timestandNavItem = document.querySelector('.dropdown__nav li:nth-child(1)');
  const timetravellerNavItem = document.querySelector('.dropdown__nav li:nth-child(2)');

  // Selektiere die Produktgruppen anhand ihrer spezifischen Klassen
  const timestandGroup = document.querySelector('.dropdown__product-group--timestand');
  const timetravellerGroup = document.querySelector('.dropdown__product-group--timetraveller');

  console.log("Timestand Nav Item:", timestandNavItem);
  console.log("Timetraveller Nav Item:", timetravellerNavItem);
  console.log("Timestand Group:", timestandGroup);
  console.log("Timetraveller Group:", timetravellerGroup);

  if (timestandNavItem && timetravellerNavItem && timestandGroup && timetravellerGroup) {
    timestandNavItem.addEventListener("mouseenter", function() {
      console.log("Hover über Timestand (LI)");
      // Zeige Timestand, verstecke Timetraveller
      timestandGroup.classList.remove("dropdown__product-group--hidden");
      timetravellerGroup.classList.add("dropdown__product-group--hidden");
    });
    timetravellerNavItem.addEventListener("mouseenter", function() {
      console.log("Hover über Timetraveller (LI)");
      // Zeige Timetraveller, verstecke Timestand
      timetravellerGroup.classList.remove("dropdown__product-group--hidden");
      timestandGroup.classList.add("dropdown__product-group--hidden");
    });
  } else {
    console.error("LI-Elemente oder Produktgruppen nicht gefunden");
  }
});
